<cigna-footer-global
  [loggedIn]="isSecure"
  [isMedical]="isMedical"
  class="theme-cigna"
></cigna-footer-global>
